import React, { useState, useEffect } from 'react';
import '../styles/sales.css';
import SalesReport from '../components/SalesReport';
import { useSearchParams } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import Select from "react-select/async";
import debounce from "debounce-promise";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEye } from '@fortawesome/free-solid-svg-icons';
import { getAPIToken } from '../services/authservice';
import { getBrandColor, getImage, getItemdata, makeSalesSheetTitles } from '../services/dataservice';

const BASE_URL = process.env.REACT_APP_DATA_API || 'http://localhost:5224/';

const SalesSheet = () => {
    const { instance } = useMsal(); // ✅ MSAL instance
    const [metric, setMetric] = useState("metric");
    const [locale, setLocale] = useState("en");
    const [subLocale, setSubLocale] = useState("none");
    const [submit, setSubmit] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [Ddoptions, setDdoptions] = useState([]);
    const [pid, setpID] = useState();
    const [exportPDF, setExportPDF] = useState(false);
    const [defaultOptions, setDefaultOptions] = useState([]);

    // ✅ getOptions uses MSAL token
    const getOptions = debounce(async (inputValue) => {
        try {
            const token = await getAPIToken(instance);

            if (!token) {
                console.error('No token available');
                return [];
            }

            const headers = {
                Authorization: `Bearer ${token}`,
            };

            const query = inputValue ? `&searchText=${inputValue}` : "";

            const response = await axios.get(
                `${BASE_URL}api/Items?page=1&pageSize=10${query}`,
                { headers }
            );

            if (Array.isArray(response.data)) {
                return response.data.slice(0, 10).map((item) => ({
                    value: item.item_No,
                    label: item.item_No + " - " + item.description,
                }));
            } else {
                console.error('Response data is not an array');
                return [];
            }
        } catch (error) {
            console.error('There was an error fetching the options:', error);
            return [];
        }
    }, 1000);

    const exportTOPDF = () => {
        const previousTitle = document.title;
        document.title = `Sales_SpecSheet_${pid.value ?? ''}`;
        window.print();
        document.title = previousTitle;
    };

    const isPDFReady = (readyVal) => {
        setExportPDF(readyVal);
    };

    const handleOptions = (Ddoptions) => {
        setDdoptions(Ddoptions);
    };

    const handleChange = (e) => {
        isPDFReady(false);
        setSubmit(false);
        console.log(e.value);
        setpID({
            value: e.value,
            label: e.label,
        });
    };

    const handleLocale = (e) => {
        isPDFReady(false);
        setSubmit(false);
        setLocale(e.target.value);
        searchParams.set("locale", e.target.value);
    };

    const handleSubLocale = (e) => {
        isPDFReady(false);
        setSubmit(false);
        setSubLocale(e.target.value);
    };

    const handleMetric = (e) => {
        isPDFReady(false);
        setSubmit(false);
        setMetric(e.target.value);
    };

    const handleSubmit = () => {
        if (pid) {
            setSubmit(true);
        } else {
            alert("Product ID is required.");
        }
    };

    useEffect(() => {
        // ✅ No more getJWTToken — MSAL handles auth

        if (searchParams.get("id")) {
            const ParamID = searchParams.get("id");
            getOptions(ParamID).then((options) => {
                if (options?.length > 0) {
                    setpID({
                        value: options[0].value,
                        label: options[0].label
                    });
                }
            });
        } else {
            getOptions("").then((options) => {
                setDefaultOptions(options);
            });
        }

        if (searchParams.get("locale")) {
            const locale_param = searchParams.get("locale");
            const opts = document.getElementById("localeSelect").options;
            const vals = Array.from(opts).map(el => el.value);
            if (vals.includes(locale_param)) {
                document.getElementById("localeSelect").value = locale_param;
                setLocale(locale_param);
            }
        }

        if (searchParams.get("sublocale")) {
            const sublocale_param = searchParams.get("sublocale");
            const opts = document.getElementById("sublocaleSelect")?.options;
            if (opts) {
                const vals = Array.from(opts).map(el => el.value);
                if (vals.includes(sublocale_param)) {
                    document.getElementById("sublocaleSelect").value = sublocale_param;
                    setSubLocale(sublocale_param);
                }
            }
        }

    }, [searchParams]);

    return (
        <div className="container-fluid">
            <div className='containerInput mt-2 no-print'>
                <div className="row m-3">
                    <div className="col col-md-2 col-sm-12">
                        <span className='Inputtitles'>Product ID</span>
                        <Select
                            cacheOptions
                            defaultOptions={defaultOptions}
                            loadOptions={getOptions}
                            value={pid}
                            placeholder="Start typing to search..."
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col col-md-2 col-12 mt-3">
                        <span className='Inputtitles'>Metric Imperial</span>
                        <select
                            className="form-select selectbar"
                            defaultValue={metric}
                            onChange={handleMetric}
                        >
                            <option value="metric">Metric</option>
                            <option value="imperial">Imperial</option>
                        </select>
                    </div>
                    <div className="col col-md-2 col-12 mt-3">
                        <span className='Inputtitles'>Locale</span>
                        <select
                            id="localeSelect"
                            className="form-select selectbar"
                            defaultValue={locale}
                            onChange={handleLocale}
                        >
                            <option value="en">English</option>
                            <option value="fr">French</option>
                        </select>
                    </div>
                    <div className="col col-md-2 col-12 mt-3">
                        <button
                            className='btn viewBtn'
                            onClick={handleSubmit}
                        >
                            View report <FontAwesomeIcon icon={faEye} />
                        </button>
                    </div>
                    <div className="col col-md-2 col-12 mt-3">
                        {exportPDF
                            ? <button
                                className='btn downBtn'
                                onClick={exportTOPDF}
                                title="Choose &quot;Save as PDF&quot; in the print dialog. Enable &quot;Background graphics&quot; for colors and images."
                              >
                                Save PDF <FontAwesomeIcon icon={faDownload} />
                              </button>
                            : null
                        }
                    </div>
                </div>
            </div>
            {submit
                ? <SalesReport
                    productID={pid.value}
                    locale={locale}
                    subLocale={subLocale}
                    metric={metric}
                    pdfReady={isPDFReady}
                  />
                : <p className="reportLoading no-print">
                    Please select item and click view report.
                  </p>
            }
        </div>
    );
};

export default SalesSheet;